export const EntityType = {
    BUSINESS: 'Business',
    CLIENT: 'Client',
    MERCHANT: 'Merchant',
};
